(function () {
  'use strict';

  angular
    .module('itecAdministracio.usuaris.main.submain.dades')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('usuaris.main.submain.dades', {
        url: '/dades',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosUsuarisHeaderSubmenuLinksValue){
                return permisosUsuarisHeaderSubmenuLinksValue;
              }
            }
          },
          'content@usuaris.main.submain': {
            templateUrl: 'usuaris/main/dades/dades.tpl.html',
            controller: 'UsuarisMainDadesCtrl',
            controllerAs: 'ctrl',
            resolve: {
              usuariData: function(UsuariFactory, $stateParams) {
                if ($stateParams.isNew){
                  return {};
                }
                else if (!angular.isUndefined($stateParams.idUsuari)
                          && $stateParams.idUsuari !== null
                          && $stateParams.idUsuari) {
                  return UsuariFactory.getview($stateParams.idUsuari).catch(function(){});
                }
                else {
                  return {};
                }
              }
            }
          }
        },
        breadcrumb: 'DEFAULT_DADES_GENERALS'
      });
  }
}());
